import React from 'react'

import {
  SurveyGroupSelector,
  type SurveyGroupSelectorProps,
} from '~/components/features/SurveyGroupSelector'
import { useCurrentSurveyGroupIdState } from '~/hooks/useCurrentSurveyGroupIdState'
import { useLogEvent } from '~/hooks/useLogEvent'
import { exists } from '~/utils'

import {
  type SurveyGroup,
  useMainQuerySurveyGroups,
} from '../../hooks/useMainQuery'

export const SurveyGroupSelectorContainer = () => {
  const surveyGroups = useMainQuerySurveyGroups()

  const [surveyGroupId, setSurveyGroupId] = useCurrentSurveyGroupIdState()

  const logEvent = useLogEvent()
  const handleChange = React.useCallback<
    EH<SurveyGroupSelectorProps<SurveyGroup>, 'onChange'>
  >(
    (surveyGroupId) => {
      setSurveyGroupId(surveyGroupId)
      const surveyGroup = surveyGroups.find(
        (surveyGroup) => surveyGroup.id === surveyGroupId,
      )
      if (exists(surveyGroup)) {
        logEvent('Select time series survey group', {
          eventProperties: [{ key: 'survey group', value: surveyGroup.title }],
        })
      }
    },
    [logEvent, setSurveyGroupId, surveyGroups],
  )

  return (
    <SurveyGroupSelector
      surveyGroups={surveyGroups}
      value={surveyGroupId ?? null}
      width={240}
      onChange={handleChange}
    />
  )
}
